angular.module('web.cloudplatform', [])
    .controller('rootCtrl', ['$scope', function ($scope) {
        function callback() {
            var winHeight = $(window).height();
            var scrollTop = $(window).scrollTop();
            $(".stage-lazy").each(function () {
                var top = $(this).offset().top;
                if (top - scrollTop <= winHeight) {
                    $(this).removeClass('hide');
                } else if (top - scrollTop > winHeight) {
                    $(this).addClass('hide');
                }
            });
        }
        var timeoutRef;
        callback();
        window.addEventListener('scroll', function () {
            if (timeoutRef) {
                clearTimeout(timeoutRef);
            }
            timeoutRef = setTimeout(callback, 50);
        });
        $(function() {
            $(".functionIntroduce-tabs-header li").hover(function() {
                $(".functionIntroduce-tabs-header li").removeClass('active');
                $(this).addClass('active');
                var tabsName = $(this).data("tabs");
                $('.functionIntroduce-tabs-body li').hide();
                $('.' + tabsName).show();
            });
            $(".threeContrast-tabs-header dd").hover(function() {
                $(".threeContrast-tabs-header dd").removeClass('active');
                $(this).addClass('active');
                var tabsName = $(this).data("tabs");
                $('.threeContrast-tabs-body-content').removeClass("active");
                $('.' + tabsName).addClass("active");
            });
        });
        
    }]);